import React from 'react'
import {connect} from "react-redux";
import Bm from "./Bm";
import Windowbutton from "../../../gui/windowbutton";
import c from "../../../etc/Const";
import {backgroundColor} from "./style";

const BmBox = ({bm_nodes, acc_nodes}) => {

    let xx = []
    for (let k of Object.keys(bm_nodes)) {
        xx.push(<Bm key={bm_nodes[k].uid} nodeid={bm_nodes[k].uid} header={true}/>)
    }

    const _width = 11 * c.p1
    const _height = window.innerHeight*2/3

    return (
        <Windowbutton close={() => {
        }} headline={'Rückmelder'} id={'BM'} width={_width} icon={'BM'}>
            <div style={{
                background: backgroundColor,
                border: '1px, solid, black',
                display: 'inline',
                position: 'absolute',
                maxHeight: _height,
                width: _width,
                overflow: 'auto',
            }}>
                {xx}
            </div>
        </Windowbutton>
    )
}

function mapStateToProps(state, other) {
    var itms = state.bidib.data.node.filter((itm) => {
        return itm.features.FEATURE_BM_SIZE > 0
    });
    var itms_acc = state.bidib.data.node.filter((itm) => {
        return itm.features.FEATURE_ACCESSORY_COUNT > 0
    });
    return {bm_nodes: itms, acc_nodes: itms_acc};
}

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(BmBox)